import { render, staticRenderFns } from "./standard-grid-layout.vue?vue&type=template&id=53202095&scoped=true"
import script from "./standard-grid-layout.vue?vue&type=script&lang=js"
export * from "./standard-grid-layout.vue?vue&type=script&lang=js"
import style0 from "./standard-grid-layout.vue?vue&type=style&index=0&id=53202095&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53202095",
  null
  
)

export default component.exports